import styled from '@emotion/styled';
import { NodeData } from 'react-folder-tree';
import { v4 as uuidv4 } from 'uuid';

export const TaskInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0px 0px 15px;
  min-height: 20px;
  border-radius: 5px;
  max-width: 200px;
  min-width: 200px;
  background: white;
  margin-top: 15px;
  margin-right: 10px;
`;

export const TaskInformationBloco = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0px 0px 15px;
  min-height: 20px;
  border-radius: 5px;
  min-width: 800px;
  background: white;
  margin-top: 15px;
  margin-right: 10px;
`;

export const TaskList = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  min-width: 250px;
  border-radius: 5px;
  padding: 15px 15px;
  max-height: 610px;
  min-height: 300px;
  overflow: auto;
`;

export const Title = styled.span`
  color: #10957d;
  background: rgba(16, 149, 125, 0.15);
  padding: 2px 10px;
  border-radius: 5px;
  align-self: flex-start;
`;

export function values_nfe() {

  let order = 0

  const itens: NodeData = {
    "name": "NF-es",
    "children": [
      {
        "name": "NF-e",
        "children": [
          {
            id: uuidv4(),
            name: "Chave NF-e",
            xml: "nfe_chv",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Modelo",
            xml: "nfe_cod_mod",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Série",
            xml: "nfe_ser",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Número",
            xml: "nfe_num_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data Emissão",
            xml: "nfe_dt_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data de Entrada/Saída",
            xml: "nfe_dt_e_s",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código Estado",
            xml: "nfe_cod_estado",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código Numérico",
            xml: "nfe_cod_num",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Natureza Operação",
            xml: "nfe_nat_op",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Processo de Emissão",
            xml: "nfe_proc_emi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo de Emissão",
            xml: "nfe_tp_emis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo da Nota Fiscal",
            xml: "nfe_tp_nf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Emit",
            xml: "nfe_emit_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Emit",
            xml: "nfe_emit_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome Fantasia - Emit",
            xml: "nfe_emit_fant",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Emit",
            xml: "nfe_emit_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Emit",
            xml: "nfe_emit_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Dest",
            xml: "nfe_dest_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Dest",
            xml: "nfe_dest_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Dest",
            xml: "nfe_dest_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Dest",
            xml: "nfe_dest_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          {
            id: uuidv4(),
            name: "BC - Total",
            xml: "nfe_vl_bc_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "BC ST - Total",
            xml: "nfe_vl_bc_icms_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Total",
            xml: "nfe_vl_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS ST - Total",
            xml: "nfe_vl_icms_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI - Total",
            xml: "nfe_vl_ipi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Frete - Total",
            xml: "nfe_vl_frt",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "NFE - Total",
            xml: "nfe_vl_nfe",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Produtos - Total",
            xml: "nfe_vl_merc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Desconto - Total",
            xml: "nfe_vl_desc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Outras Despesas - Total",
            xml: "nfe_vl_outro",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI Devolução - Total",
            xml: "nfe_ipi_devol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS - Total",
            xml: "nfe_vl_pis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "FCP - Total",
            xml: "nfe_vl_fcp",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "FCP ST - Total",
            xml: "nfe_vl_fcp_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS - Total",
            xml: "nfe_vl_cofins",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Transportador",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Transp",
            xml: "nfe_transp_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Transp",
            xml: "nfe_transp_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Transp",
            xml: "nfe_transp_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Município - Transp",
            xml: "nfe_transp_mun",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Transp",
            xml: "nfe_transp_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Volume - Transp",
            xml: "nfe_transp_vol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Espécie - Transp",
            xml: "nfe_transp_esp",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Peso Líquido - Transp",
            xml: "nfe_transp_pesol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Peso Bruto - Transp",
            xml: "nfe_transp_pesob",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo Placa - Transp",
            xml: "nfe_transp_veiculo_placa",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo UF - Transp",
            xml: "nfe_transp_veiculo_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo RNTC - Transp",
            xml: "nfe_transp_veiculo_rntc",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Produtos",
        "children": [
          {
            id: uuidv4(),
            name: "Código - Produto",
            xml: "prod_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "EAN - Produto",
            xml: "prod_ean",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome - Produto",
            xml: "prod_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Número - Produto",
            xml: "prod_numero",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "NCM - Produto",
            xml: "prod_ncm",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CEST - Produto",
            xml: "prod_cest",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CFOP - Produto",
            xml: "prod_cfop",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor - Produto",
            xml: "prod_vl_opr",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "EAN Tribu. - Produto",
            xml: "prod_ean_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Desconto - Produto",
            xml: "prod_desc",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Unidade - Produto",
            xml: "prod_un",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Quantidade - Produto",
            xml: "prod_quanti",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor Unitário - Produto",
            xml: "prod_unit",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Unidade Tribu. - Produto",
            xml: "prod_un_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Quantidade Tribu. - Produto",
            xml: "prod_quanti_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor Unitário Tribu. - Produto",
            xml: "prod_unit_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI CST - Produto",
            xml: "prod_cst_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI BC - Produto",
            xml: "prod_vl_bc_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS CST - Produto",
            xml: "prod_cst_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS BC - Produto",
            xml: "prod_vl_bc_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS CST - Produto",
            xml: "prod_cst_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS BC - Produto",
            xml: "prod_vl_bc_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS CST - Produto",
            xml: "prod_cst_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS BC - Produto",
            xml: "prod_vl_bc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS BCST - Produto",
            xml: "prod_vl_bc_icms_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Produto",
            xml: "prod_vl_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA ST - Produto",
            xml: "prod_vl_mva_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS ST - Produto",
            xml: "prod_vl_icms_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI - Produto",
            xml: "prod_vl_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Aliq. IPI - Produto",
            xml: "prod_aliq_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS - Produto",
            xml: "prod_vl_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS - Produto",
            xml: "prod_vl_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Outras Despesas - Produto",
            xml: "prod_vl_outro",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          {
            id: uuidv4(),
            name: "Nome - Cálculo",
            xml: "calc_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido de - Cálculo",
            xml: "calc_valido_de",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido até - Cálculo",
            xml: "calc_valido_ate",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Cálculo",
            xml: "calc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Nome - Cálculo",
            xml: "calc_classi_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Código Receita - Cálculo",
            xml: "calc_classi_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA - Cálculo",
            xml: "calc_mva",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor FCP calculado - Cálculo",
            xml: "calc_fcp",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor ICM calculado - Cálculo",
            xml: "calc_icms_ant",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          {
            id: uuidv4(),
            name: "Fisico - Info",
            xml: "nfe_inf_fisico",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CPL - Info",
            xml: "nfe_inf_cpl",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. CNPJ - Info",
            xml: "nfe_inf_resp_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Contato - Info",
            xml: "nfe_inf_resp_contato",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Email - Info",
            xml: "nfe_inf_resp_email",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Fone - Info",
            xml: "nfe_inf_resp_fone",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_nfes = [
  {
    id: uuidv4(),
    name: "Chave NF-e",
    xml: "nfe_chv",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Modelo",
    xml: "nfe_cod_mod",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Série",
    xml: "nfe_ser",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Número",
    xml: "nfe_num_doc",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Data Emissão",
    xml: "nfe_dt_doc",
    tag: "NF-e",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Data de Entrada/Saída",
    xml: "nfe_dt_e_s",
    tag: "NF-e",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Código Estado",
    xml: "nfe_cod_estado",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Código Numérico",
    xml: "nfe_cod_num",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Natureza Operação",
    xml: "nfe_nat_op",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Processo de Emissão",
    xml: "nfe_proc_emi",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo de Emissão",
    xml: "nfe_tp_emis",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo da Nota Fiscal",
    xml: "nfe_tp_nf",
    tag: "NF-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Emit",
    xml: "nfe_emit_cnpj",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Emit",
    xml: "nfe_emit_nome",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome Fantasia - Emit",
    xml: "nfe_emit_fant",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Emit",
    xml: "nfe_emit_ie",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Emit",
    xml: "nfe_emit_uf",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Dest",
    xml: "nfe_dest_cnpj",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Dest",
    xml: "nfe_dest_nome",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Dest",
    xml: "nfe_dest_ie",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Dest",
    xml: "nfe_dest_uf",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "BC - Total",
    xml: "nfe_vl_bc_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "BC ST - Total",
    xml: "nfe_vl_bc_icms_st",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS - Total",
    xml: "nfe_vl_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS ST - Total",
    xml: "nfe_vl_icms_st",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI - Total",
    xml: "nfe_vl_ipi",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Frete - Total",
    xml: "nfe_vl_frt",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "NFE - Total",
    xml: "nfe_vl_nfe",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Produto - Total",
    xml: "nfe_vl_merc",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Desconto - Total",
    xml: "nfe_vl_desc",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Outras Despesas - Total",
    xml: "nfe_vl_outro",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI Devolução - Total",
    xml: "nfe_ipi_devol",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS - Total",
    xml: "nfe_vl_pis",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "FCP - Total",
    xml: "nfe_vl_fcp",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "FCP ST - Total",
    xml: "nfe_vl_fcp_st",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS - Total",
    xml: "nfe_vl_cofins",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Transp",
    xml: "nfe_transp_cnpj",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Transp",
    xml: "nfe_transp_nome",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Transp",
    xml: "nfe_transp_ie",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Município - Transp",
    xml: "nfe_transp_mun",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Transp",
    xml: "nfe_transp_uf",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Volume - Transp",
    xml: "nfe_transp_vol",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Espécie - Transp",
    xml: "nfe_transp_esp",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Peso Líquido - Transp",
    xml: "nfe_transp_pesol",
    tag: "Transportador",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Peso Bruto - Transp",
    xml: "nfe_transp_pesob",
    tag: "Transportador",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Veiculo Placa - Transp",
    xml: "nfe_transp_veiculo_placa",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Veiculo UF - Transp",
    xml: "nfe_transp_veiculo_uf",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Veiculo RNTC - Transp",
    xml: "nfe_transp_veiculo_rntc",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Código - Produto",
    xml: "prod_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "EAN - Produto",
    xml: "prod_ean",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome - Produto",
    xml: "prod_nome",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Número - Produto",
    xml: "prod_numero",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "NCM - Produto",
    xml: "prod_ncm",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CEST - Produto",
    xml: "prod_cest",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CFOP - Produto",
    xml: "prod_cfop",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor - Produto",
    xml: "prod_vl_opr",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "EAN Tribu. - Produto",
    xml: "prod_ean_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Desconto - Produto",
    xml: "prod_desc",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Unidade - Produto",
    xml: "prod_un",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Quantidade - Produto",
    xml: "prod_quanti",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Unitário - Produto",
    xml: "prod_unit",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Unidade Tribu. - Produto",
    xml: "prod_un_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Quantidade Tribu. - Produto",
    xml: "prod_quanti_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Unitário Tribu. - Produto",
    xml: "prod_unit_trib",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI CST - Produto",
    xml: "prod_cst_ipi",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "IPI BC - Produto",
    xml: "prod_vl_bc_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS CST - Produto",
    xml: "prod_cst_pis",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "PIS BC - Produto",
    xml: "prod_vl_bc_pis",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS CST - Produto",
    xml: "prod_cst_cofins",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "COFINS BC - Produto",
    xml: "prod_vl_bc_cofins",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS CST - Produto",
    xml: "prod_cst_icms",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "ICMS BC - Produto",
    xml: "prod_vl_bc_icms",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS BC ST - Produto",
    xml: "prod_vl_bc_icms_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS - Produto",
    xml: "prod_vl_icms",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "MVA ST - Produto",
    xml: "prod_vl_mva_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS ST - Produto",
    xml: "prod_vl_icms_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI - Produto",
    xml: "prod_vl_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Aliq. IPI - Produto",
    xml: "prod_aliq_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS - Produto",
    xml: "prod_vl_pis",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS - Produto",
    xml: "prod_vl_cofins",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Outras Despesas - Produto",
    xml: "prod_vl_outro",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Nome - Cálculo",
    xml: "calc_nome",
    tag: "Produtos",
    value: "calculo"
  },
  {
    id: uuidv4(),
    name: "Valido de - Cálculo",
    xml: "calc_valido_de",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Valido até - Cálculo",
    xml: "calc_valido_ate",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "ICMS - Cálculo",
    xml: "calc_icms",
    tag: "Produtos",
    value: "boolean"
  },
  {
    id: uuidv4(),
    name: "Class. Nome - Cálculo",
    xml: "calc_classi_nome",
    tag: "Produtos",
    value: "classificacao"
  },
  {
    id: uuidv4(),
    name: "Class. Código Receita - Cálculo",
    xml: "calc_classi_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "MVA - Cálculo",
    xml: "calc_mva",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor FCP calculado - Cálculo",
    xml: "calc_fcp",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor ICM calculado - Cálculo",
    xml: "calc_icms_ant",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Fisico - Info",
    xml: "nfe_inf_fisico",
    tag: "NFE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CPL - Info",
    xml: "nfe_inf_cpl",
    tag: "NFE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. CNPJ - Info",
    xml: "nfe_inf_resp_cnpj",
    tag: "NFE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Contato - Info",
    xml: "nfe_inf_resp_contato",
    tag: "NFE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Email - Info",
    xml: "nfe_inf_resp_email",
    tag: "NFE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Fone - Info",
    xml: "nfe_inf_resp_fone",
    tag: "NFE-e",
    value: "string"
  }
]

export function values_cte() {

  let order = 0

  let itens: NodeData = {
    "name": "CT-es",
    "children": [
      {
        "name": "CT-e",
        "children": [
          {
            id: uuidv4(),
            name: "Chave CT-e",
            xml: "cte_chv",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Número",
            xml: "cte_num_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código UF",
            xml: "cte_cod_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código Modelo",
            xml: "cte_cod_mod",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CFOP",
            xml: "cte_cfop",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Série",
            xml: "cte_ser",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data Emissão",
            xml: "cte_data_emi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Emit",
            xml: "cte_emit_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Emit",
            xml: "cte_emit_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome Fantasia - Emit",
            xml: "cte_emit_fant",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Emit",
            xml: "cte_emit_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Emit",
            xml: "cte_emit_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Remetente",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Remet",
            xml: "cte_rem_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Remet",
            xml: "cte_rem_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Remet",
            xml: "cte_rem_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Estado - Remet",
            xml: "cte_rem_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Dest",
            xml: "cte_dest_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Dest",
            xml: "cte_dest_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Dest",
            xml: "cte_dest_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Estado - Dest",
            xml: "cte_dest_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          {
            id: uuidv4(),
            name: "ICMS - Total",
            xml: "cte_vl_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS CST - Total",
            xml: "cte_cst_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "BC - Total",
            xml: "cte_vl_bc_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CTE - Total",
            xml: "cte_vl_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          {
            id: uuidv4(),
            name: "Nome - Cálculo",
            xml: "calc_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido de - Cálculo",
            xml: "calc_valido_de",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido até - Cálculo",
            xml: "calc_valido_ate",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Cálculo",
            xml: "calc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Nome - Cálculo",
            xml: "calc_classi_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Código Receita - Cálculo",
            xml: "calc_classi_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA - Cálculo",
            xml: "calc_mva",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor FCP calculado - Cálculo",
            xml: "calc_fcp",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor ICM calculado - Cálculo",
            xml: "calc_icms_ant",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          {
            id: uuidv4(),
            name: "Resp. CNPJ - Info",
            xml: "cte_inf_resp_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Contato - Info",
            xml: "cte_inf_resp_contato",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Email - Info",
            xml: "cte_inf_resp_email",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Fone - Info",
            xml: "cte_inf_resp_fone",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_ctes = [
  {
    id: uuidv4(),
    name: "Chave CT-e",
    xml: "cte_chv",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Número",
    xml: "cte_num_doc",
    tag: "CTE-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Código UF",
    xml: "cte_cod_uf",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Código Modelo",
    xml: "cte_cod_mod",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CFOP",
    xml: "cte_cfop",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Série",
    xml: "cte_ser",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Data Emissão",
    xml: "cte_data_emi",
    tag: "CT-e",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Emit",
    xml: "cte_emit_cnpj",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Emit",
    xml: "cte_emit_nome",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome Fantasia - Emit",
    xml: "cte_emit_fant",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Emit",
    xml: "cte_emit_ie",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Emit",
    xml: "cte_emit_uf",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Remet",
    xml: "cte_rem_cnpj",
    tag: "Remetente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Remet",
    xml: "cte_rem_nome",
    tag: "Remetente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Remet",
    xml: "cte_rem_ie",
    tag: "Remetente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Estado - Remet",
    xml: "cte_rem_ie",
    tag: "Remetente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Dest",
    xml: "cte_dest_cnpj",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Dest",
    xml: "cte_dest_nome",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Dest",
    xml: "cte_dest_ie",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Estado - Dest",
    xml: "cte_dest_uf",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "ICMS - Total",
    xml: "cte_vl_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS CST - Total",
    xml: "cte_cst_icms",
    tag: "Valores Totais",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "BC - Total",
    xml: "cte_vl_bc_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "CTE - Total",
    xml: "cte_vl_doc",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Nome - Cálculo",
    xml: "calc_nome",
    tag: "Produtos",
    value: "calculo"
  },
  {
    id: uuidv4(),
    name: "Valido de - Cálculo",
    xml: "calc_valido_de",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Valido até - Cálculo",
    xml: "calc_valido_ate",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "ICMS - Cálculo",
    xml: "calc_icms",
    tag: "Produtos",
    value: "boolean"
  },
  {
    id: uuidv4(),
    name: "Class. Nome - Cálculo",
    xml: "calc_classi_nome",
    tag: "Produtos",
    value: "classificacao"
  },
  {
    id: uuidv4(),
    name: "Class. Código Receita - Cálculo",
    xml: "calc_classi_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "MVA - Cálculo",
    xml: "calc_mva",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor FCP calculado - Cálculo",
    xml: "calc_fcp",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor ICM calculado - Cálculo",
    xml: "calc_icms_ant",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Resp. CNPJ - Info",
    xml: "cte_inf_resp_cnpj",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Contato - Info",
    xml: "cte_inf_resp_contato",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Email - Info",
    xml: "cte_inf_resp_email",
    tag: "CT-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Fone - Info",
    xml: "cte_inf_resp_fone",
    tag: "CT-e",
    value: "string"
  }
]

export function values_nfce() {

  let order = 0

  const itens: NodeData = {
    "name": "NFC-es",
    "children": [
      {
        "name": "NFC-e",
        "children": [
          {
            id: uuidv4(),
            name: "Chave NFC-e",
            xml: "nfe_chv",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Modelo",
            xml: "nfe_cod_mod",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Série",
            xml: "nfe_ser",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Número",
            xml: "nfe_num_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data Emissão",
            xml: "nfe_dt_doc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data de Entrada/Saída",
            xml: "nfe_dt_e_s",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código Estado",
            xml: "nfe_cod_estado",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Código Numérico",
            xml: "nfe_cod_num",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Natureza Operação",
            xml: "nfe_nat_op",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Processo de Emissão",
            xml: "nfe_proc_emi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo de Emissão",
            xml: "nfe_tp_emis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo da Nota Fiscal",
            xml: "nfe_tp_nf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Emit",
            xml: "nfe_emit_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Emit",
            xml: "nfe_emit_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome Fantasia - Emit",
            xml: "nfe_emit_fant",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Emit",
            xml: "nfe_emit_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Emit",
            xml: "nfe_emit_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Dest",
            xml: "nfe_dest_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Dest",
            xml: "nfe_dest_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Dest",
            xml: "nfe_dest_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Dest",
            xml: "nfe_dest_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          {
            id: uuidv4(),
            name: "BC - Total",
            xml: "nfe_vl_bc_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "BC ST - Total",
            xml: "nfe_vl_bc_icms_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Total",
            xml: "nfe_vl_icms",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS ST - Total",
            xml: "nfe_vl_icms_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI - Total",
            xml: "nfe_vl_ipi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Frete - Total",
            xml: "nfe_vl_frt",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "NFCE - Total",
            xml: "nfe_vl_nfe",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Produtos - Total",
            xml: "nfe_vl_merc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Desconto - Total",
            xml: "nfe_vl_desc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Outras Despesas - Total",
            xml: "nfe_vl_outro",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI Devolução - Total",
            xml: "nfe_ipi_devol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS - Total",
            xml: "nfe_vl_pis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "FCP - Total",
            xml: "nfe_vl_fcp",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "FCP ST - Total",
            xml: "nfe_vl_fcp_st",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS - Total",
            xml: "nfe_vl_cofins",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Transportador",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Transp",
            xml: "nfe_transp_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Razão Social - Transp",
            xml: "nfe_transp_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Inscrição Estadual - Transp",
            xml: "nfe_transp_ie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Município - Transp",
            xml: "nfe_transp_mun",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Transp",
            xml: "nfe_transp_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Volume - Transp",
            xml: "nfe_transp_vol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Espécie - Transp",
            xml: "nfe_transp_esp",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Peso Líquido - Transp",
            xml: "nfe_transp_pesol",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Peso Bruto - Transp",
            xml: "nfe_transp_pesob",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo Placa - Transp",
            xml: "nfe_transp_veiculo_placa",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo UF - Transp",
            xml: "nfe_transp_veiculo_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Veiculo RNTC - Transp",
            xml: "nfe_transp_veiculo_rntc",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Produtos",
        "children": [
          {
            id: uuidv4(),
            name: "Código - Produto",
            xml: "prod_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "EAN - Produto",
            xml: "prod_ean",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome - Produto",
            xml: "prod_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Número - Produto",
            xml: "prod_numero",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "NCM - Produto",
            xml: "prod_ncm",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CEST - Produto",
            xml: "prod_cest",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CFOP - Produto",
            xml: "prod_cfop",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor - Produto",
            xml: "prod_vl_opr",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "EAN Tribu. - Produto",
            xml: "prod_ean_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Desconto - Produto",
            xml: "prod_desc",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Unidade - Produto",
            xml: "prod_un",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Quantidade - Produto",
            xml: "prod_quanti",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor Unitário - Produto",
            xml: "prod_unit",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Unidade Tribu. - Produto",
            xml: "prod_un_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Quantidade Tribu. - Produto",
            xml: "prod_quanti_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor Unitário Tribu. - Produto",
            xml: "prod_unit_trib",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI CST - Produto",
            xml: "prod_cst_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI BC - Produto",
            xml: "prod_vl_bc_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS CST - Produto",
            xml: "prod_cst_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS BC - Produto",
            xml: "prod_vl_bc_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS CST - Produto",
            xml: "prod_cst_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS BC - Produto",
            xml: "prod_vl_bc_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS CST - Produto",
            xml: "prod_cst_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS BC - Produto",
            xml: "prod_vl_bc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS BCST - Produto",
            xml: "prod_vl_bc_icms_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Produto",
            xml: "prod_vl_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA ST - Produto",
            xml: "prod_vl_mva_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS ST - Produto",
            xml: "prod_vl_icms_st",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IPI - Produto",
            xml: "prod_vl_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Aliq. IPI - Produto",
            xml: "prod_aliq_ipi",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "PIS - Produto",
            xml: "prod_vl_pis",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "COFINS - Produto",
            xml: "prod_vl_cofins",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Outras Despesas - Produto",
            xml: "prod_vl_outro",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          {
            id: uuidv4(),
            name: "Nome - Cálculo",
            xml: "calc_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido de - Cálculo",
            xml: "calc_valido_de",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido até - Cálculo",
            xml: "calc_valido_ate",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Cálculo",
            xml: "calc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Nome - Cálculo",
            xml: "calc_classi_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Código Receita - Cálculo",
            xml: "calc_classi_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA - Cálculo",
            xml: "calc_mva",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor FCP calculado - Cálculo",
            xml: "calc_fcp",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor ICM calculado - Cálculo",
            xml: "calc_icms_ant",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          {
            id: uuidv4(),
            name: "Fisico - Info",
            xml: "nfe_inf_fisico",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "CPL - Info",
            xml: "nfe_inf_cpl",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. CNPJ - Info",
            xml: "nfe_inf_resp_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Contato - Info",
            xml: "nfe_inf_resp_contato",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Email - Info",
            xml: "nfe_inf_resp_email",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Resp. Fone - Info",
            xml: "nfe_inf_resp_fone",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens
}

export const sorted_tags_nfces = [
  {
    id: uuidv4(),
    name: "Chave NFC-e",
    xml: "nfe_chv",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Modelo",
    xml: "nfe_cod_mod",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Série",
    xml: "nfe_ser",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Número",
    xml: "nfe_num_doc",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Data Emissão",
    xml: "nfe_dt_doc",
    tag: "NFC-e",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Data de Entrada/Saída",
    xml: "nfe_dt_e_s",
    tag: "NFC-e",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Código Estado",
    xml: "nfe_cod_estado",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Código Numérico",
    xml: "nfe_cod_num",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Natureza Operação",
    xml: "nfe_nat_op",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Processo de Emissão",
    xml: "nfe_proc_emi",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo de Emissão",
    xml: "nfe_tp_emis",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo da Nota Fiscal",
    xml: "nfe_tp_nf",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Emit",
    xml: "nfe_emit_cnpj",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Emit",
    xml: "nfe_emit_nome",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome Fantasia - Emit",
    xml: "nfe_emit_fant",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Emit",
    xml: "nfe_emit_ie",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Emit",
    xml: "nfe_emit_uf",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Dest",
    xml: "nfe_dest_cnpj",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Dest",
    xml: "nfe_dest_nome",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Dest",
    xml: "nfe_dest_ie",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Dest",
    xml: "nfe_dest_uf",
    tag: "Destinatário",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "BC - Total",
    xml: "nfe_vl_bc_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "BC ST - Total",
    xml: "nfe_vl_bc_icms_st",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS - Total",
    xml: "nfe_vl_icms",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS ST - Total",
    xml: "nfe_vl_icms_st",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI - Total",
    xml: "nfe_vl_ipi",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Frete - Total",
    xml: "nfe_vl_frt",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "NFCE - Total",
    xml: "nfe_vl_nfe",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Produto - Total",
    xml: "nfe_vl_merc",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Desconto - Total",
    xml: "nfe_vl_desc",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Outras Despesas - Total",
    xml: "nfe_vl_outro",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI Devolução - Total",
    xml: "nfe_ipi_devol",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS - Total",
    xml: "nfe_vl_pis",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "FCP - Total",
    xml: "nfe_vl_fcp",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS - Total",
    xml: "nfe_vl_cofins",
    tag: "Valores Totais",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Transp",
    xml: "nfe_transp_cnpj",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Razão Social - Transp",
    xml: "nfe_transp_nome",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Inscrição Estadual - Transp",
    xml: "nfe_transp_ie",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Município - Transp",
    xml: "nfe_transp_mun",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Transp",
    xml: "nfe_transp_uf",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Volume - Transp",
    xml: "nfe_transp_vol",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Espécie - Transp",
    xml: "nfe_transp_esp",
    tag: "Transportador",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Peso Líquido - Transp",
    xml: "nfe_transp_pesol",
    tag: "Transportador",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Peso Bruto - Transp",
    xml: "nfe_transp_pesob",
    tag: "Transportador",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Veiculo Placa - Transp",
    xml: "nfe_transp_veiculo_placa",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Veiculo UF - Transp",
    xml: "nfe_transp_veiculo_uf",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Veiculo RNTC - Transp",
    xml: "nfe_transp_veiculo_rntc",
    tag: "Transportador",
    value: "string",
  },
  {
    id: uuidv4(),
    name: "Código - Produto",
    xml: "prod_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "EAN - Produto",
    xml: "prod_ean",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome - Produto",
    xml: "prod_nome",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Número - Produto",
    xml: "prod_numero",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "NCM - Produto",
    xml: "prod_ncm",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CEST - Produto",
    xml: "prod_cest",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CFOP - Produto",
    xml: "prod_cfop",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor - Produto",
    xml: "prod_vl_opr",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "EAN Tribu. - Produto",
    xml: "prod_ean_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Desconto - Produto",
    xml: "prod_desc",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Unidade - Produto",
    xml: "prod_un",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Quantidade - Produto",
    xml: "prod_quanti",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Unitário - Produto",
    xml: "prod_unit",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Unidade Tribu. - Produto",
    xml: "prod_un_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Quantidade Tribu. - Produto",
    xml: "prod_quanti_trib",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Unitário Tribu. - Produto",
    xml: "prod_unit_trib",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI CST - Produto",
    xml: "prod_cst_ipi",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "IPI BC - Produto",
    xml: "prod_vl_bc_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS CST - Produto",
    xml: "prod_cst_pis",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "PIS BC - Produto",
    xml: "prod_vl_bc_pis",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS CST - Produto",
    xml: "prod_cst_cofins",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "COFINS BC - Produto",
    xml: "prod_vl_bc_cofins",
    tag: "Produtos",
    value: "number"
  },

  {
    id: uuidv4(),
    name: "ICMS CST - Produto",
    xml: "prod_cst_icms",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "ICMS BC - Produto",
    xml: "prod_vl_bc_icms",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS BC ST - Produto",
    xml: "prod_vl_bc_icms_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS - Produto",
    xml: "prod_vl_icms",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "MVA ST - Produto",
    xml: "prod_vl_icms_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "ICMS ST - Produto",
    xml: "prod_vl_mva_st",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "IPI - Produto",
    xml: "prod_vl_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Aliq. IPI - Produto",
    xml: "prod_aliq_ipi",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "PIS - Produto",
    xml: "prod_vl_pis",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "COFINS - Produto",
    xml: "prod_vl_cofins",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Outras Despesas - Produto",
    xml: "prod_vl_outro",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Nome - Cálculo",
    xml: "calc_nome",
    tag: "Produtos",
    value: "calculo"
  },
  {
    id: uuidv4(),
    name: "Valido de - Cálculo",
    xml: "calc_valido_de",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Valido até - Cálculo",
    xml: "calc_valido_ate",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "ICMS - Cálculo",
    xml: "calc_icms",
    tag: "Produtos",
    value: "boolean"
  },
  {
    id: uuidv4(),
    name: "Class. Nome - Cálculo",
    xml: "calc_classi_nome",
    tag: "Produtos",
    value: "classificacao"
  },
  {
    id: uuidv4(),
    name: "Class. Código Receita - Cálculo",
    xml: "calc_classi_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "MVA - Cálculo",
    xml: "calc_mva",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor FCP calculado - Cálculo",
    xml: "calc_fcp",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor ICM calculado - Cálculo",
    xml: "calc_icms_ant",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Fisico - Info",
    xml: "nfe_inf_fisico",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CPL - Info",
    xml: "nfe_inf_cpl",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. CNPJ - Info",
    xml: "nfe_inf_resp_cnpj",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Contato - Info",
    xml: "nfe_inf_resp_contato",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Email - Info",
    xml: "nfe_inf_resp_email",
    tag: "NFC-e",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Resp. Fone - Info",
    xml: "nfe_inf_resp_fone",
    tag: "NFC-e",
    value: "string"
  }
]

export function values_nfse() {

  let order = 0

  let itens: NodeData = {
    "name": "NFS-es",
    "children": [
      {
        "name": "NFS-e",
        "children": [
          {
            id: uuidv4(),
            name: "Chave - NFS-e",
            xml: "nfse_chave",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Local Prestação - NFS-e",
            xml: "nfse_local_prestacao",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Num. NFSe - NFS-e",
            xml: "nfse_cod_nfse",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Cod. Local Incid - NFS-e",
            xml: "nfse_cod_local_incid",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Local Incid - NFS-e",
            xml: "nfse_local_incid",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tributação Nacional - NFS-e",
            xml: "nfse_trib_nac",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tributação Municipal - NFS-e",
            xml: "nfse_trib_mun",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Local Emissão - NFS-e",
            xml: "nfse_local_emit",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Ambiente Gerenciamento - NFS-e",
            xml: "nfse_amb_ger",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo Emissão - NFS-e",
            xml: "nfse_tipo_emis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Processo Emissão - NFS-e",
            xml: "nfse_proc_emis",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Cod. Status - NFS-e",
            xml: "nfse_cod_stat",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data Processamento - NFS-e",
            xml: "nfse_data_proc",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Numero NFSe - NFS-e",
            xml: "nfse_num_nfse",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Emit",
            xml: "nfse_emit_cnpj",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "IM - Emit",
            xml: "nfse_emit_im",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Nome - Emit",
            xml: "nfse_emit_nome",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "UF - Emit",
            xml: "nfse_emit_uf",
            checked: 0,
            campo: "info",
            order: order += 1
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores",
        "children": [
          {
            id: uuidv4(),
            name: "Valor Toal Retido - Valores",
            xml: "nfse_valor_total_ret",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor Liq - Valores",
            xml: "nfse_valor_liq",
            checked: 0,
            campo: "info",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Documento",
        "children": [
          {
            id: uuidv4(),
            name: "CNPJ - Documento",
            xml: "nfse_tipo_amb",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Data Emissão - Documento",
            xml: "nfse_data_emit",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Serie - Documento",
            xml: "nfse_serie",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Num. DPS - Documento",
            xml: "nfse_num_doc_prest_serv",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Competencia - Documento",
            xml: "nfse_data_competencia",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Tipo Emissão - Documento",
            xml: "nfse_tipo_emit",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Cod. Local Emissão - Documento",
            xml: "nfse_cod_local_emi",
            checked: 0,
            campo: "info",
            order: order += 1
          },
          {
            "name": "Prestador",
            "children": [
              {
                id: uuidv4(),
                name: "CNPJ - Prestador",
                xml: "nfse_prest_cnpj",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "IM - Prestador",
                xml: "nfse_prest_im",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Telefone - Prestador",
                xml: "nfse_prest_fone",
                checked: 0,
                campo: "fone",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "E-Mail - Prestador",
                xml: "nfse_prest_email",
                checked: 0,
                campo: "email",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Op. Simples - Prestador",
                xml: "nfse_prest_op_simples",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Simples - Prestador",
                xml: "nfse_prest_regime_simples",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Especial - Prestador",
                xml: "nfse_prest_regime_especial",
                checked: 0,
                campo: "info",
                order: order += 1
              }
            ],
            "_id": uuidv4(),
            checked: 0,
            isOpen: false
          },
          {
            "name": "Tomador",
            "children": [
              {
                id: uuidv4(),
                name: "CNPJ - Tomador",
                xml: "nfse_toma_cnpj",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Nome - Tomador",
                xml: "nfse_toma_nome",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Cód. Município - Tomador",
                xml: "nfse_toma_cod_municipio",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "CEP - Tomador",
                xml: "nfse_toma_cep",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Logradouro - Tomador",
                xml: "nfse_toma_lgr",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Número - Tomador",
                xml: "nfse_toma_nro",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Complemento - Tomador",
                xml: "nfse_toma_cpl",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Bairro - Tomador",
                xml: "nfse_toma_bairro",
                checked: 0,
                campo: "info",
                order: order += 1
              }
            ],
            "_id": uuidv4(),
            checked: 0,
            isOpen: false
          },
          {
            "name": "Serviço",
            "children": [
              {
                id: uuidv4(),
                name: "Cod. Local - Serviço",
                xml: "nfse_serv_cod_local_prestacao",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Cod. Nacional - Serviço",
                xml: "nfse_serv_cod_trib_nac",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Cod. Municipal - Serviço",
                xml: "nfse_serv_cod_trib_mun",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Descrição - Serviço",
                xml: "nfse_serv_desc_servico",
                checked: 0,
                campo: "info",
                order: order += 1
              }

            ],
            "_id": uuidv4(),
            checked: 0,
            isOpen: false
          },
          {
            "name": "Valores",
            "children": [
              {
                id: uuidv4(),
                name: "Serviço - Valores",
                xml: "nfse_valor_serv",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Trib. ISSQN - Valores",
                xml: "nfse_trib_issqn",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Ret. ISSQN - Valores",
                xml: "nfse_tipo_ret_issqn",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Percentual Simples - Valores",
                xml: "nfse_percentual_tot_trib_simples",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Base de Cálculo PIS/COFINS - Valores",
                xml: "nfse_base_calculo_pis_cofins",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Alíquota PIS - Valores",
                xml: "nfse_aliquota_pis",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Alíquota COFINS - Valores",
                xml: "nfse_aliquota_cofins",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor PIS - Valores",
                xml: "nfse_valor_pis",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor COFINS - Valores",
                xml: "nfse_valor_cofins",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Tipo de Retorno PIS/COFINS - Valores",
                xml: "nfse_tipo_retorno_pis_cofins",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Retido CP - Valores",
                xml: "nfse_valor_retido_cp",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Retido IRRF - Valores",
                xml: "nfse_valor_retido_irrf",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Retido CSLL - Valores",
                xml: "nfse_valor_retido_csll",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Total Tributos Federais - Valores",
                xml: "nfse_valor_total_tributos_federais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Total Tributos Estaduais - Valores",
                xml: "nfse_valor_total_tributos_estaduais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Valor Total Tributos Municipais - Valores",
                xml: "nfse_valor_total_tributos_municipais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Percentual Total Tributos Federais - Valores",
                xml: "nfse_percentual_total_tributos_federais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Percentual Total Tributos Estaduais - Valores",
                xml: "nfse_percentual_total_tributos_estaduais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Percentual Total Tributos Municipais - Valores",
                xml: "nfse_percentual_total_tributos_municipais",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Indicador Total Tributos - Valores",
                xml: "nfse_indicador_total_tributos",
                checked: 0,
                campo: "info",
                order: order += 1
              },
              {
                id: uuidv4(),
                name: "Percentual Total Tributos Simples Nacional - Valores",
                xml: "nfse_percentual_total_tributos_simples_nacional",
                checked: 0,
                campo: "info",
                order: order += 1
              }
            ],
            "_id": uuidv4(),
            checked: 0,
            isOpen: false
          },
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          {
            id: uuidv4(),
            name: "Nome - Cálculo",
            xml: "calc_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido de - Cálculo",
            xml: "calc_valido_de",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valido até - Cálculo",
            xml: "calc_valido_ate",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "ICMS - Cálculo",
            xml: "calc_icms",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Nome - Cálculo",
            xml: "calc_classi_nome",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Class. Código Receita - Cálculo",
            xml: "calc_classi_cod",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "MVA - Cálculo",
            xml: "calc_mva",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor FCP calculado - Cálculo",
            xml: "calc_fcp",
            checked: 0,
            campo: "item",
            order: order += 1
          },
          {
            id: uuidv4(),
            name: "Valor ICM calculado - Cálculo",
            xml: "calc_icms_ant",
            checked: 0,
            campo: "item",
            order: order += 1
          }
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_nfses = [
  {
    id: uuidv4(),
    name: "Chave - NFS-e",
    tag: "NFS-E",
    xml: "nfse_chave",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Local Emissão - NFS-e",
    tag: "NFS-E",
    xml: "nfse_local_emit",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Local Prestação - NFS-e",
    tag: "NFS-E",
    xml: "nfse_local_prestacao",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Num. NFSe - NFS-e",
    tag: "NFS-E",
    xml: "nfse_cod_nfse",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Local Incid - NFS-e",
    tag: "NFS-E",
    xml: "nfse_cod_local_incid",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Local Incid - NFS-e",
    tag: "NFS-E",
    xml: "nfse_local_incid",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tributação Nacional - NFS-e",
    tag: "NFS-E",
    xml: "nfse_trib_nac",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tributação Municipal - NFS-e",
    tag: "NFS-E",
    xml: "nfse_trib_mun",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Ambiente Gerenciamento - NFS-e",
    tag: "NFS-E",
    xml: "nfse_amb_ger",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo Emissão - NFS-e",
    tag: "NFS-E",
    xml: "nfse_tipo_emis",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Processo Emissão - NFS-e",
    tag: "NFS-E",
    xml: "nfse_proc_emis",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Status - NFS-e",
    tag: "NFS-E",
    xml: "nfse_cod_stat",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Data Processamento - NFS-e",
    tag: "NFS-E",
    xml: "nfse_data_proc",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Numero NFSe - NFS-e",
    tag: "NFS-E",
    xml: "nfse_num_nfse",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Emit",
    xml: "nfse_emit_cnpj",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "IM - Emit",
    xml: "nfse_emit_im",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome - Emit",
    xml: "nfse_emit_nome",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "UF - Emit",
    xml: "nfse_emit_uf",
    tag: "Emitente",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Toal Retido - Valores",
    xml: "nfse_valor_total_ret",
    tag: "Valores",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Liq - Valores",
    xml: "nfse_valor_liq",
    tag: "Valores",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Documento",
    tag: "Documento",
    xml: "nfse_tipo_amb",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Data Emissão - Documento",
    tag: "Documento",
    xml: "nfse_data_emit",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Serie - Documento",
    tag: "Documento",
    xml: "nfse_serie",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Num. DPS - Documento",
    tag: "Documento",
    xml: "nfse_num_doc_prest_serv",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Competencia - Documento",
    tag: "Documento",
    xml: "nfse_data_competencia",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Tipo Emissão - Documento",
    tag: "Documento",
    xml: "nfse_tipo_emit",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Local Emissão - Documento",
    tag: "Documento",
    xml: "nfse_cod_local_emi",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Prestador",
    xml: "nfse_prest_cnpj",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "IM - Prestador",
    xml: "nfse_prest_im",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Op. Simples - Prestador",
    xml: "nfse_prest_op_simples",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Simples - Prestador",
    xml: "nfse_prest_regime_simples",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Especial - Prestador",
    xml: "nfse_prest_regime_especial",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "CNPJ - Tomador",
    xml: "nfse_toma_cnpj",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome - Tomador",
    xml: "nfse_toma_nome",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Local - Serviço",
    xml: "nfse_serv_cod_local_prestacao",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Nacional - Serviço",
    xml: "nfse_serv_cod_trib_nac",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Cod. Municipal - Serviço",
    xml: "nfse_serv_cod_trib_mun",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Descrição - Serviço",
    xml: "nfse_serv_desc_servico",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Serviço - Valores",
    xml: "nfse_valor_serv",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Trib. ISSQN - Valores",
    xml: "nfse_trib_issqn",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Ret. ISSQN - Valores",
    xml: "nfse_tipo_ret_issqn",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Percentual Simples - Valores",
    xml: "nfse_percentual_tot_trib_simples",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Nome - Cálculo",
    xml: "calc_nome",
    tag: "Produtos",
    value: "calculo"
  },
  {
    id: uuidv4(),
    name: "Valido de - Cálculo",
    xml: "calc_valido_de",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "Valido até - Cálculo",
    xml: "calc_valido_ate",
    tag: "Produtos",
    value: "data"
  },
  {
    id: uuidv4(),
    name: "ICMS - Cálculo",
    xml: "calc_icms",
    tag: "Produtos",
    value: "boolean"
  },
  {
    id: uuidv4(),
    name: "Class. Nome - Cálculo",
    xml: "calc_classi_nome",
    tag: "Produtos",
    value: "classificacao"
  },
  {
    id: uuidv4(),
    name: "Class. Código Receita - Cálculo",
    xml: "calc_classi_cod",
    tag: "Produtos",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "MVA - Cálculo",
    xml: "calc_mva",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor FCP calculado - Cálculo",
    xml: "calc_fcp",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor ICM calculado - Cálculo",
    xml: "calc_icms_ant",
    tag: "Produtos",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Base de Cálculo PIS/COFINS - Valores",
    xml: "nfse_base_calculo_pis_cofins",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Alíquota PIS - Valores",
    xml: "nfse_aliquota_pis",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Alíquota COFINS - Valores",
    xml: "nfse_aliquota_cofins",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor PIS - Valores",
    xml: "nfse_valor_pis",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor COFINS - Valores",
    xml: "nfse_valor_cofins",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Tipo de Retorno PIS/COFINS - Valores",
    xml: "nfse_tipo_retorno_pis_cofins",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Valor Retido CP - Valores",
    xml: "nfse_valor_retido_cp",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Retido IRRF - Valores",
    xml: "nfse_valor_retido_irrf",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Retido CSLL - Valores",
    xml: "nfse_valor_retido_csll",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Total Tributos Federais - Valores",
    xml: "nfse_valor_total_tributos_federais",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Total Tributos Estaduais - Valores",
    xml: "nfse_valor_total_tributos_estaduais",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Valor Total Tributos Municipais - Valores",
    xml: "nfse_valor_total_tributos_municipais",
    tag: "Documento",
    value: "number"
  },
  {
    id: uuidv4(),
    name: "Percentual Total Tributos Federais - Valores",
    xml: "nfse_percentual_total_tributos_federais",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Percentual Total Tributos Estaduais - Valores",
    xml: "nfse_percentual_total_tributos_estaduais",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Percentual Total Tributos Municipais - Valores",
    xml: "nfse_percentual_total_tributos_municipais",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Indicador Total Tributos - Valores",
    xml: "nfse_indicador_total_tributos",
    tag: "Documento",
    value: "string"
  },
  {
    id: uuidv4(),
    name: "Percentual Total Tributos Simples Nacional - Valores",
    xml: "nfse_percentual_total_tributos_simples_nacional",
    tag: "Documento",
    value: "string"
  }
]